import React from 'react';
import { Link } from 'react-router-dom';
import { Leaf, ShieldCheck } from 'lucide-react';

export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#232f3e] text-gray-300 text-xs mt-auto">
      
      {/* Back to Top Button */}
      <button 
        onClick={scrollToTop} 
        className="w-full bg-[#37475a] hover:bg-[#485769] text-white py-3 font-bold text-center transition-colors shadow-inner"
      >
        Back to top
      </button>

      {/* Main Footer Links Columns */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 grid grid-cols-2 md:grid-cols-4 gap-8">
        
        <div>
          <h4 className="font-bold text-white text-sm mb-3">Get to Know Us</h4>
          <ul className="space-y-2">
            <li><Link to="/" className="hover:underline">About EcoStore</Link></li>
            <li><Link to="/" className="hover:underline">Careers & Sustainability</Link></li>
            <li><Link to="/" className="hover:underline">Press Releases</Link></li>
            <li><Link to="/" className="hover:underline">Amazon Science / Eco-Goals</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-bold text-white text-sm mb-3">Make Money with Us</h4>
          <ul className="space-y-2">
            <li><Link to="/admin" className="hover:underline">Sell products on EcoStore</Link></li>
            <li><Link to="/" className="hover:underline">Protect & Build Your Brand</Link></li>
            <li><Link to="/" className="hover:underline">Advertise Your Products</Link></li>
            <li><Link to="/" className="hover:underline">Eco-Affiliate Program</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-bold text-white text-sm mb-3">Let Us Help You</h4>
          <ul className="space-y-2">
            <li><Link to="/my-orders" className="hover:underline">Your Account & Orders</Link></li>
            <li><Link to="/track-order" className="hover:underline">Shipping Rates & Policies</Link></li>
            <li><Link to="/shop" className="hover:underline">Returns & Replacements</Link></li>
            <li><Link to="/" className="hover:underline">Help Center</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-bold text-white text-sm mb-3">Eco Guarantees</h4>
          <ul className="space-y-2">
            <li><span className="flex items-center space-x-1"><ShieldCheck className="h-4 w-4 text-emerald-400" /><span>100% Organic Verified</span></span></li>
            <li><span className="flex items-center space-x-1"><Leaf className="h-4 w-4 text-emerald-400" /><span>Zero-Plastic Packaging</span></span></li>
          </ul>
        </div>

      </div>

      {/* Bottom Sub-Footer Bar */}
      <div className="border-t border-gray-700 bg-[#131921] py-8 text-center text-[11px] text-gray-400">
        <div className="flex items-center justify-center space-x-2 mb-2">
          <span className="font-black text-lg text-white">Eco<span className="text-amber-400">Store</span></span>
          <Leaf className="h-4 w-4 text-emerald-400" />
        </div>
        <p>© 2026, EcoStore.in, Inc. or its affiliates. Built with React & Firebase.</p>
      </div>

    </footer>
  );
}